import React, { useEffect, useState } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import profile from '../../../assets/img/Sculpt-logo.png';
import AppoinmentUpdate from './AppoinmentUpdate';
import AppoinmentDelete from './AppoinmentDelete';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { allAppointmentDetail, appointementConfirm, appointementGet, slipAppointment } from '../../../redux/actions/Files.action';
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import { BARCODE_URL } from 'baseUrl';
import userPhoto from '../../../assets/img/user.png'
import JsBarcode from 'jsbarcode';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addFeedback } from '../../../redux/actions/Feedback.action';
import moment from 'moment';
import { MdWhatsapp } from 'react-icons/md';
import { getMessage } from '../../../redux/actions/Setting.action';
import { BASEURL } from '../../../baseUrl';

const AppoinmentView = ({ setViewModal, viewModal, viewToggle, currentDate, data, limits, feedbackId }) => {

  const [selectedSource, setSelectedSource] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const appointmentId = useSelector((state) => state.files)
  const [show, setShow] = useState(false);
  const toggle = () => { setShow(!show); setViewModal(false) }
  const dispatch = useDispatch()
  const type = localStorage.getItem('type')
  const appointmentData = appointmentId?.getAppointmentById?.data?.appointmentData;

  const initialValues = {
    feedback: ''
  }

  const validationSchema = Yup.object().shape({
    feedback: Yup.string().required('Feedback is required')
  });

  const handleFeedbackDetail = (values, { resetForm }) => {
    const payload = {
      patientId: feedbackId,
      feedback: values.feedback
    }

    dispatch(addFeedback(payload)).then(() => {
      toggle();
      resetForm();
    });
  };

  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
    setViewModal(false);
  };
  const updateToggle = () => {
    setUpdateModal(!updateModal);
    viewToggle();
    setViewModal(false);
  };

  function handleSelectChange(event) {
    setSelectedSource(event.target.value);
  }

  const handleConfirm = () => {
    dispatch(appointementConfirm(appointmentData._id, data, currentDate, limits)).then(() => {
      viewToggle()
    })
  }

  useEffect(() => {
    if (appointmentData?._id) {
      dispatch(slipAppointment(appointmentData?._id))
    }
  }, [appointmentData])

  const slipData = appointmentId?.slipAppointment?.data?.SlipData

  const calculateAge = (dateOfBirth) => {
    const dob = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDifference = today.getMonth() - dob.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return age;
  };

  const ageData = slipData?.dateOfBirth;
  const age = calculateAge(ageData);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formattedDate = formatDate(appointmentData?.createdAt);
  const genderInitial = slipData?.gender ? slipData.gender.charAt(0) : '';
  const referance = slipData?.referance?.[0];
  let formattedReference = "";

  if (referance) {
    if (referance.doctorDetail) {
      formattedReference = `Doctor / ${referance.doctorDetail}`;
    } else if (referance.personDetail) {
      formattedReference = `Person / ${referance.personDetail}`;
    }
  }

  const handleDownload = async () => {
    const data = {
      patientcode: slipData?.patientcode,
      firstName: slipData?.firstName,
      lastName: slipData?.lastName,
      phoneNumber: slipData?.phoneNumber,
      area: slipData?.area,
      doctor: slipData?.doctor,
      barcode: slipData?.barcode,
      fileDate: formattedDate,
      gender: genderInitial,
      referance: formattedReference
    };

    // Generate a barcode image using JsBarcode and create a data URL
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, data.phoneNumber, {
      format: "CODE128",
      displayValue: true,
      width: 1,
      height: 50,  // Adjust height as needed
      fontSize: 12,
      textMargin: 5,
    });
    const barcodeImage = canvas.toDataURL('image/png');

    // Create a new window
    const newWindow = window.open('', '_blank');

    // Write HTML content directly to the new window
    newWindow.document.write(`
        <html>
            <head>
                <title>Print Slip</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        font-size:10pt;
                    }
                    
                    .barcode {
                        margin-top: 20px;
                    }
                </style>
            </head>
            <body>
                <div class="content">
                    <p style="margin-top:1px;"><b>Name:</b> ${data.firstName} ${data.lastName}</p>
                    <p style="margin-top:-5px;"><b>Phone:</b> ${data.phoneNumber} | <b>Age:</b> ${age} / ${data.gender}</p>
                    <p style="margin-top:-5px;"><b>Area:</b> ${data.area}</p>
                    <p style="margin-top:-5px;"><b>Doctor Name:</b> ${data.doctor}</p>
                    <p style="margin-top:-5px;"><b>Reference Name:</b> ${data.referance}</p>
                    <p style="margin-top:-5px;"><b>Reg. Code:</b> ${data.patientcode} | <b>Reg. Date:</b> ${data.fileDate}</p>
                </div>
            </body>
        </html>
    `);

    // <div class="barcode">
    //   <img src="${barcodeImage}" alt="Barcode" />
    // </div>
    // Close the document to apply the HTML content
    newWindow.document.close();

    // Wait for the new window to fully load and then print it
    newWindow.onload = () => {
      newWindow.print();
      newWindow.onafterprint = () => {
        newWindow.close();
      };
    };
  };

  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [whatsappDropdownSelection, setWhatsappDropdownSelection] = useState('');
  const [whatsAppMessage, setWhatsAppMessage] = useState([]);
  const [otherMessage, setOtherMessage] = useState('');
  const [errors, setErrors] = useState({ dropdown: '', other: '' });
  const [selectedPatientName, setSelectedPatientName] = useState('');
  const [selectedMobileNumber, setSelectedMobileNumber] = useState('');

  useEffect(() => {
    dispatch(getMessage())
      .then((res) => {
        if (res?.status == 200) {
          setWhatsAppMessage(res?.data?.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const openWhatsappModal = (mobileNumber, firstName, lastName) => {
    setSelectedMobileNumber(mobileNumber);
    setSelectedPatientName(`${firstName} ${lastName}`);
    setIsWhatsappModalOpen(true);
  };

  const closeWhatsappModal = () => {
    setIsWhatsappModalOpen(false);
    setWhatsappDropdownSelection('');
    setOtherMessage('');
    setErrors({ dropdown: '', other: '' });
  };

  const handleSend = () => {
    let hasError = false;
    const newErrors = { dropdown: '', other: '' };

    if (!whatsappDropdownSelection) {
      newErrors.dropdown = 'Please select a message option.';
      hasError = true;
    }

    if (whatsappDropdownSelection === 'other' && !otherMessage.trim()) {
      newErrors.other = 'Please enter your custom message.';
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    let formattedNumber = selectedMobileNumber;
    if (!formattedNumber.startsWith('91')) {
      formattedNumber = `91${formattedNumber}`;
    }

    let messageToSend = '';
    if (whatsappDropdownSelection === 'other') {
      messageToSend = otherMessage;
      setOtherMessage('');
    } else {
      const selectedMsgObj = whatsAppMessage.find((msg) => msg._id === whatsappDropdownSelection);
      messageToSend = selectedMsgObj?.description || '';
      setOtherMessage('');
    }

    const encodedMessage = encodeURIComponent(messageToSend);
    const whatsappURL = `https://api.whatsapp.com/send?phone=${formattedNumber}&text=${encodedMessage}`;

    window.open(whatsappURL, '_blank');
    closeWhatsappModal();
  };

  return (
    <>
      <Modal show={viewModal} onHide={viewToggle} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            appointmentData ? (
              <div className="flex justify-between px-4">
                <div>
                  <Table borderless>
                    <tbody>
                      <tr>
                        <td>Patient Code </td>
                        <td>:</td>
                        <td>{appointmentData?.patientcode}</td>
                      </tr>
                      <tr>
                        <td>Phone Number </td>
                        <td>:</td>
                        <td>{appointmentData?.phoneNumber}</td>
                      </tr>
                      <tr>
                        <td>Appointment Date</td>
                        <td>:</td>
                        <td>{appointmentData?.dateOfAppointment ? moment(appointmentData?.dateOfAppointment).format('DD/MM/YYYY') : ''}</td>
                      </tr>
                      <tr>
                        <td>Appointment Time</td>
                        <td>:</td>
                        <td>{appointmentData?.time}</td>
                      </tr>

                      <tr>
                        <td>Dr. Name </td>
                        <td>:</td>
                        <td>{appointmentData?.doctor}</td>
                      </tr>
                      <tr>
                        <td>At place (Branch) </td>
                        <td>:</td>
                        <td>{appointmentData?.branch}</td>
                      </tr>
                      <tr>
                        <td>Last Remark</td>
                        <td>:</td>
                        <td>{appointmentData?.remark}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div className="">
                  <Table borderless>
                    <tbody>
                      <tr>
                        <td>Payment Due</td>
                        <td>:</td>
                        <td style={{ color: 'red' }}><strong>{appointmentData?.totalPendingAmountSum}</strong></td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="w-[150px] h-[150px] flex justify-center items-center border-1 border-dark rounded-circle">
                    <img
                      src={appointmentData && appointmentData.patientImage && appointmentData.patientImage.length > 0 ? 
                        "https://sculptskincare.cloud/api/uploads/" + appointmentData?.patientImage : 
                        userPhoto}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = userPhoto;
                      }}
                      alt="imaghe"
                      className="w-full h-full object-cover rounded-circle"
                    />
                  </div>
                  <div className='mt-3'>
                    <Button onClick={() => { handleDownload() }} className="!bg-theme-dark border-0 px-4">Download Sleep</Button>
                  </div>
                </div>
              </div>
            ) : (
              <p>Loading data...</p>
            )
          }

          <div className="flex gap-2 mt-3">
            <a href={`/doctor/clinical/${appointmentData?._id}`} className="!bg-theme-dark border-0 block rounded py-[6px] px-3 text-white cursor-pointer">Clinical</a>
            <a href={`/master/callLog/${appointmentData?._id}`} className="!bg-theme-dark border-0 block rounded py-[6px] px-3 text-white">Call log</a>
            <a href={`/master/generateBill/${appointmentData?._id}`} className="!bg-theme-dark border-0 block rounded py-[6px] px-3 text-white">Account</a>
            <Button className='!bg-theme-dark !border-theme-dark px-3' onClick={toggle}>Feedback</Button>
            <div className="d-flex gap-2 fs-6 fw-bold" onClick={() => openWhatsappModal(appointmentData?.phoneNumber, appointmentData?.firstName, appointmentData?.lastName)}>
              <MdWhatsapp className="text-success" size={35}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {
            appointmentData?.status === 'pending' && (
              <Button onClick={handleConfirm} className="!bg-theme-dark border-0 px-4">
                Confirm
              </Button>
            )
          }

          <Button
            onClick={updateToggle}
            className="!bg-theme-dark border-0 px-4"
          >
            Edit
          </Button>
          <Button
            onClick={deleteToggle}
            className="!bg-theme-dark border-0 px-4"
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <AppoinmentUpdate updateModal={updateModal} updateToggle={updateToggle} appointmentData={appointmentData} currentDate={currentDate} limits={limits} />
      <AppoinmentDelete deleteModal={deleteModal} deleteToggle={deleteToggle} appointmentData={appointmentData} currentDate={currentDate} limits={limits} />

      {/* Add feedBack */}
      <Modal show={show} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Feedback</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleFeedbackDetail}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Feedback</Form.Label>
                      <Form.Control
                        type="text"
                        name="feedback"
                        as='textarea'
                        rows={3}
                        onChange={(e) =>
                          setFieldValue('feedback', e.target.value)}
                        value={values.feedback}
                        placeholder="Enter Feedback"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="feedback"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={toggle} className="px-4 bg-transparent border-[1px] text-black border-green-color" >
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0 px-4" >
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* WhatsApp Modal */}
      <Modal show={isWhatsappModalOpen} onHide={closeWhatsappModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Patient Name</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedPatientName}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Mobile Number</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedMobileNumber}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Select Message</Form.Label>
              <Form.Select
                className="border-2"
                value={whatsappDropdownSelection}
                onChange={(e) => {
                  setWhatsappDropdownSelection(e.target.value);
                  setErrors((prev) => ({ ...prev, dropdown: '' }));
                }}
              >
                <option value="">Select Option</option>
                {whatsAppMessage.map((msg) => (
                  <option key={msg._id} value={msg._id}>
                    {msg.title}
                  </option>
                ))}
                <option value="other">Other</option>
              </Form.Select>
              {errors.dropdown && (
                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.dropdown}</div>
              )}
            </div>

            {whatsappDropdownSelection === 'other' && (
              <div className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Please specify"
                  className="border-2"
                  value={otherMessage}
                  onChange={(e) => {
                    setOtherMessage(e.target.value);
                    setErrors((prev) => ({ ...prev, other: '' }));
                  }}
                />
                {errors.other && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.other}</div>
                )}
              </div>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeWhatsappModal}>
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSend}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AppoinmentView;
